const isObject = (it: unknown): it is {} => typeof it === `object` && it !== null

export default isObject
